import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-datepicker-report',
  templateUrl: './custom-datepicker-report.component.html',
  styleUrls: ['./custom-datepicker-report.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomDatepickerReportComponent),
      multi: true
    }
  ],
  imports: [CommonModule, DatePickerModule, FormsModule, ReactiveFormsModule, TableModule]
})
export class CustomDatepickerReportComponent implements ControlValueAccessor {

  onChange: (value: Date | null) => void = () => { };
  onTouched: () => void = () => { };
  disabled: boolean = false;
  value: Date | null = null;

  @Input() labelText: string = "";
  @Input() recovery: boolean = false;
  @Input() required: boolean = false;
  @Output() onChangeDate = new EventEmitter<Date | null>();

  changeDate(event: Date | null): void {
    this.value = event;
    this.onChange(event);
    this.onTouched();
    this.onChangeDate.emit(event);
  }

  registerOnChange(fn: (value: Date | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: Date | null): void {
    this.value = value;
  }

}
